import type { IProduct } from '../models/product';
import type { Product } from '../models/product-legacy';

export type TSkuCategory = Omit<Product.ParentedCategory, 'parent'>;

/**
 * Функция распаковывает иерархическую модель характеристик в одномерный массив.
 * @param {IProduct} product - Выбранный продукт.
 * @return {TSkuCategory[]} список SKU категорий продукта.
 */
export function productToCategories(product: IProduct): TSkuCategory[] {
  const { parentList, ...skuCategory } = product.category;

  return [...parentList, skuCategory];
}
